/**
 * novostrojki-bar.js — каталог ЖК: два ряда отбора сведены в один блок
 * (дизайн 20.08.2026, черновик tools/.hero-draft/zadacha-katalog.*).
 *
 * Пара к public/css/novostrojki-bar.css. Две задачи:
 *
 *   КАТ-1 (комп)     — параметры отбора, чипы и сортировка в одной коробке под
 *                      заголовком; сортировка отдельным выпадающим списком;
 *                      справа кнопка-карта.
 *   КАТ-2 (телефон)  — та же коробка свёрнута в аккордеон: узкая планка-сводка,
 *                      по умолчанию закрыто, список ЖК виден сразу.
 *
 * ⛔ УЗЛЫ САЙТА ПЕРЕНОСИМ, А НЕ КОПИРУЕМ. Обработчики висят на самих кнопках
 *    (novostrojki.js вешает свой слушатель на каждый .nv-tab и .nv-sort-btn,
 *    а адрес #nvMapLink переписывает при смене города без перезагрузки).
 *    Копия выглядела бы так же, но не фильтровала и не сортировала бы, а
 *    скопированный id ещё и увёл бы чужие обработчики на мёртвый узел.
 *
 * ⛔ РАЗМЕТКУ СТРОИМ ОДИН РАЗ, ПРЯЧЕТ ЛИШНЕЕ CSS. Ни одной проверки ширины в
 *    скрипте нет сознательно: альбом крупного телефона (405×928 → 928 px) ШИРЕ
 *    порога 900, и решение «телефон или комп», принятое при загрузке, стало бы
 *    односторонней дверью — открытая в альбоме страница не получила бы своего
 *    вида никогда. Всё различие живёт в @media, поэтому поворот обратим сам.
 *
 * ⛔ РАБОТАЕМ ПО DOMContentLoaded. Файл подключён через $pageJS, то есть с defer,
 *    и перенос кнопок безопасен только после того, как их подписал novostrojki.js.
 *    Порядок defer-скриптов это гарантирует, а зеркало (dev-mirror-proxy)
 *    вставляет сборку черновиков обычным <script> в конец тела, где она
 *    исполняется раньше всех штатных. Ожидание события уравнивает оба случая.
 *
 * ⛔ ДОГОВОР СО СТИЛЕМ: ДО СБОРКИ СТРАНИЦА НЕПОЛНАЯ. novostrojki-bar.css прячет
 *    фильтр-панель, ряд чипов, ссылки в шапке и список — иначе они рисуются в
 *    родных местах и переезд коробки даёт прыжок раскладки (замер 405×928:
 *    CLS 0,0148 → 0,075). Отсюда две обязанности этого файла:
 *      • по успеху — `zk-ready` на <html> (список показывается);
 *      • по любому сбою — `zk-bar-broken` на <html> (родная раскладка назад).
 *    Список вдобавок подстрахован таймером в самом CSS: он появится, даже если
 *    этот файл не исполнится вовсе.
 *
 * ⛔ ЗАЯВКА ОКНОМ ВО ВЕСЬ ЭКРАН (КАТ-3 черновика) СЮДА НЕ ПЕРЕНЕСЕНА НАМЕРЕННО.
 *    Она перехватывала .nv-card__btn-booking через capture+stopPropagation и
 *    подменяла живое окно брони (#nvBookingModal) макетом, который никуда не
 *    отправляет заявку («заявка никуда не уходит» — текст самого черновика).
 *    Выкат означал бы потерю заявок с каталога. В описании блока у владельца
 *    её тоже нет: «два ряда фильтров в один, планка-аккордеон, кнопка-карта».
 */
(() => {
  'use strict';

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  const icon = (name, cls) => {
    // ⛔ classList.add('a b') бросает исключение — пробел в токене недопустим,
    //    и весь скрипт умирал бы на первой иконке. Собираем строкой класса.
    const i = el('i', 'fas ' + name + (cls ? ' ' + cls : ''));
    i.setAttribute('aria-hidden', 'true');
    return i;
  };

  const txt = (node, fallback) => {
    const s = node && node.textContent ? node.textContent.trim() : '';
    return s || fallback || '';
  };

  /* Подпись перехода («На карте», «У метро») в разметке сайта лежит ГОЛЫМ
     текстовым узлом рядом со значком — стилем такой узел не взять. Заворачиваем
     в свой <span>, чтобы на телефоне подпись можно было убрать из вида
     обрезкой, а не нулевым размером шрифта. Возвращаем саму подпись. */
  function wrapCaption(a) {
    const has = a.querySelector('.zk-jump__cap');
    if (has) return txt(has, '');
    const parts = [];
    [...a.childNodes].forEach((n) => {
      if (n.nodeType !== 3) return;
      parts.push(n.textContent);
      a.removeChild(n);
    });
    const label = parts.join(' ').replace(/\s+/g, ' ').trim();
    if (!label) return '';
    a.appendChild(el('span', 'zk-jump__cap', label));
    return label;
  }

  /* ⛔ ЧЕЛОВЕЧЕСКОЕ ИМЯ, А НЕ ЗНАЧЕНИЕ ФИЛЬТРА. Подписи кнопок фильтра сайт
     пишет СЫРЫМ значением (`novostrojki.js:295`, `span.textContent = val`):
     после смены города там оказывается слаг латиницей («sochi», «kursk»,
     «moskvaobl»), а у комнатности — голая цифра «2». На кнопке это терпели
     годами, но планка-сводка видна на телефоне ПОСТОЯННО, и блок тем самым
     дефект усилил. Человеческое имя лежит рядом — в самом пункте выпадашки,
     у него тот же `data-val`. Берём оттуда, своего второго списка не заводим. */
  function humanLabel(filter, raw) {
    if (!raw) return '';
    const dd = document.querySelector('.nv-dropdown[data-filter="' + filter + '"]');
    if (!dd) return raw;
    const opts = dd.querySelectorAll('.nv-dropdown__opt');
    for (let i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-val') === raw) return txt(opts[i], raw);
    }
    return raw;
  }

  /* ⛔ АВАРИЙНЫЙ ВЫХОД. novostrojki-bar.css прячет ЧУЖИЕ узлы (фильтр-панель,
     ряд чипов, скелетон) ещё до сборки — иначе они успевают нарисоваться и
     переезд коробки даёт прыжок раскладки. Цена такого приёма: если сборка не
     состоялась, страница осталась бы без фильтра. Поэтому любой сбой обязан
     вернуть родную раскладку, а не оставить полупустой экран. */
  function giveUp() {
    document.documentElement.classList.add('zk-bar-broken');
  }

  function boot() {
    const main = document.querySelector('.nv-main .nv-container');
    const header = main && main.querySelector('.nv-header');
    const tabsRow = document.querySelector('.nv-tabs-row');
    const filterbar = document.getElementById('nvFilterbar');
    const tabs = document.getElementById('nvTabs');
    const sortBar = document.getElementById('nvSortBar');
    if (document.querySelector('.zk-bar')) return;   // блок уже собран
    // Пустой город («Скоро в {городе}») рисует шапку без фильтров и без чипов —
    // строить нечего. Там наш CSS не подключён вовсе, но проверку оставляем:
    // отсутствие узла не должно оборачиваться спрятанной половиной страницы.
    if (!main || !header || !tabsRow || !filterbar || !tabs || !sortBar) {
      giveUp();
      return;
    }

    document.body.classList.add('zk-katalog');

    const bar = buildBar({ tabsRow, filterbar, tabs, sortBar });
    wireAccordion(bar);
    wireSort(bar, sortBar);

    // Коробка собрана — скелетон списка можно показывать. Сдвига нет: до этой
    // строки он не нарисован ни разу, а появление нового — не сдвиг.
    document.documentElement.classList.add('zk-ready');
  }

  /* ─────────────────────────────────────────────────────────────────────
     Сборка единого блока отбора
     ───────────────────────────────────────────────────────────────────── */
  function buildBar(ctx) {
    const bar = el('section', 'zk-bar');
    bar.id = 'zkBar';

    /* Планка-сводка. Кнопка, а не div, — чтобы работала с клавиатуры и
       читалась скринридером как раскрывающаяся. */
    const sum = el('button', 'zk-bar__summary');
    sum.type = 'button';
    sum.setAttribute('aria-expanded', 'false');
    sum.setAttribute('aria-controls', 'zkBarParams');
    const sumIcon = el('span', 'zk-bar__summary-icon');
    sumIcon.appendChild(icon('fa-sliders-h'));
    const sumText = el('span', 'zk-bar__summary-text');
    sumText.appendChild(el('span', 'zk-bar__summary-title', 'Фильтры и поиск'));
    const sumDesc = el('span', 'zk-bar__summary-desc', '…');
    sumText.appendChild(sumDesc);
    sum.appendChild(sumIcon);
    sum.appendChild(sumText);
    sum.appendChild(icon('fa-chevron-down', 'zk-bar__summary-chev'));

    /* Параметры отбора (город, комнаты, цена, год, проект, метро, поиск) —
       это переехавший #nvFilterbar целиком. */
    const params = el('div', 'zk-bar__params');
    params.id = 'zkBarParams';
    params.appendChild(ctx.filterbar);

    const done = el('button', 'zk-bar__done');
    done.type = 'button';
    done.appendChild(icon('fa-check'));
    done.appendChild(el('span', null, 'Показать ЖК'));
    params.appendChild(done);

    /* Ряд «отбор + сортировка + кнопка-карта». */
    const quick = el('div', 'zk-bar__quick');
    quick.appendChild(el('span', 'zk-bar__group-label', 'Отбор'));
    quick.appendChild(ctx.tabs);
    quick.appendChild(buildSort(ctx.sortBar));
    const mini = buildMiniMap();
    if (mini) quick.appendChild(mini);

    /* Верхний ряд: планка + переходы «На карте» / «У метро» значками.
       На компе ряд целиком гасит CSS — ссылки НЕ переносятся никуда и не
       удаляются, поэтому поворот телефона в альбом и обратно ничего не ломает. */
    const toprow = el('div', 'zk-bar__toprow');
    toprow.appendChild(sum);
    // ⛔ «У метро» (#nvMetroLink) остаётся в шапке видимой кнопкой (проверка устройств 7б,
    // риск «скрытых ссылок»): эта коробка спрятана стилем колонки, и ссылка в ней была бы
    // видна роботу, но не человеку.
    const jumps = [...document.querySelectorAll('.nv-map-link:not(#nvMetroLink)')];
    if (jumps.length) {
      const box = el('div', 'zk-bar__jumps');
      jumps.forEach((a) => {
        a.classList.add('zk-jump');
        // Полное название остаётся для чтения с экрана: на телефоне CSS
        // оставляет один значок, иначе три надписи не встанут в ряд.
        const label = wrapCaption(a);
        if (label && !a.getAttribute('aria-label')) a.setAttribute('aria-label', label);
        box.appendChild(a);
      });
      toprow.appendChild(box);
    }

    bar.appendChild(toprow);
    bar.appendChild(params);
    bar.appendChild(quick);

    // Место блока — под заголовком и строкой «Найдено …» (решение владельца).
    ctx.tabsRow.parentNode.insertBefore(bar, ctx.tabsRow);
    ctx.tabsRow.classList.add('zk-emptied');   // осиротевший каркас старого ряда

    bar._sumDesc = sumDesc;
    bar._done = done;
    return bar;
  }

  /* Сортировка отдельным видом: подпись + кнопка с текущим значением +
     панель, внутрь которой переезжает РОДНОЙ #nvSortBar со своими кнопками. */
  function buildSort(sortBar) {
    const wrap = el('div', 'zk-sort');

    /* Подпись: значок + слово. На телефоне слово уносится обрезкой, остаётся
       значок — владелец 21.08: «убрать слово СОРТИРОВКА и поставить стрелки».
       На компьютере ровно наоборот: значок погашен, слово на месте.
       ⛔ Слово НЕ УДАЛЯЕМ, а прячем: с экрана его читают, и на повороте в
          альбом место под него снова появляется.
       ⛔ Имя значка — ЛИТЕРАЛОМ, и только из набора сайта: шрифт урезанный
          (`css/fontawesome/css/subset.min.css`, сборка грепает public/js), и
          отсутствующий значок рисуется пустым квадратом. `fa-arrows-up-down`
          в наборе есть (`\f07d`) и уже стоит на кнопке порядка показа у карты
          города (`catalog-map-view.js`) — тот же смысл, тот же значок. */
    const label = el('span', 'zk-sort__label');
    label.appendChild(icon('fa-arrows-up-down', 'zk-sort__ico'));
    label.appendChild(el('span', 'zk-sort__cap', 'Сортировка'));
    wrap.appendChild(label);

    const btn = el('button', 'zk-sort__btn');
    btn.type = 'button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    const val = el('span', 'zk-sort__val', currentSortLabel(sortBar));
    btn.appendChild(val);
    btn.appendChild(icon('fa-chevron-down', 'zk-sort__chev'));

    const panel = el('div', 'zk-sort__panel');
    panel.appendChild(sortBar);

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    wrap._btn = btn;
    wrap._val = val;
    return wrap;
  }

  /* Подпись кнопки, закрывающей аккордеон. При нулевой выдаче «Показать 0 ЖК»
     звучит как обещание показать пустоту — говорим прямо. */
  function doneLabel(jk, known) {
    if (!known) return 'Показать ЖК';
    if (jk === '0') return 'Ничего не найдено';
    return 'Показать ' + jk + ' ЖК';
  }

  function currentSortLabel(sortBar) {
    const active = sortBar.querySelector('.nv-sort-btn.active') || sortBar.querySelector('.nv-sort-btn');
    return txt(active, 'По умолчанию');
  }

  /* Кнопка-карта справа (владелец 20.08: «сделай "показать на карте" маленькой
     картой справа»).
     ⛔ Адрес берём у живой ссылки #nvMapLink и ДЕРЖИМ В СИНХРОНЕ: novostrojki.js
        переписывает его при смене города без перезагрузки страницы, и снятый
        один раз адрес увёл бы человека на карту прежнего города. Сочинять путь
        нельзя — у каждого города свой, его собирает CatalogMapUrl на сервере. */
  function buildMiniMap() {
    const src = document.getElementById('nvMapLink');
    const href = src && src.getAttribute('href');
    if (!href) return null;

    const mini = el('a', 'zk-minimap');
    mini.href = href;
    mini.setAttribute('aria-label', txt(src, 'Показать на карте'));

    const pic = el('span', 'zk-minimap__pic');
    pic.appendChild(icon('fa-map-location-dot'));
    mini.appendChild(pic);
    mini.appendChild(el('span', 'zk-minimap__cap', 'Показать на карте'));

    if (window.MutationObserver) {
      new MutationObserver(() => {
        const fresh = src.getAttribute('href');
        if (fresh && fresh !== mini.getAttribute('href')) mini.href = fresh;
      }).observe(src, { attributes: true, attributeFilter: ['href'] });
    }
    return mini;
  }

  /* ─────────────────────────────────────────────────────────────────────
     КАТ-2: поведение аккордеона + живая сводка
     ───────────────────────────────────────────────────────────────────── */
  function wireAccordion(bar) {
    const sum = bar.querySelector('.zk-bar__summary');
    const desc = bar._sumDesc;
    const done = bar._done;
    const totalJk = document.getElementById('nvTotalJK');

    const setOpen = (open) => {
      bar.classList.toggle('is-open', open);
      sum.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    sum.addEventListener('click', () => setOpen(!bar.classList.contains('is-open')));
    done.addEventListener('click', () => {
      setOpen(false);
      // Возврат к планке: иначе после длинного фильтра экран остаётся где-то
      // посреди свернувшегося блока и список «прыгает».
      // ⛔ Под фиксированную шапку планка НЕ уезжает, и своего вычитания высоты
      //    здесь не надо: у документа выставлен scroll-padding-top:76px, а шапка
      //    на телефоне 60px (замер на зеркале). scrollIntoView его учитывает —
      //    планка встаёт на 76,4 от верха окна. Своя арифметика давала 68,4,
      //    то есть спорила с общим правилом сайта ради восьми точек.
      try { bar.scrollIntoView({ block: 'start', behavior: 'smooth' }); } catch (e) { /* прокрутка — удобство */ }
    });

    /* Сводка собирается из живых подписей самого фильтра и из счётчика сайта,
       а не из отдельной копии состояния: две копии одного смысла всегда
       расходятся. Число ЖК берём ровно то, что сайт напечатал в «Найдено … в
       N ЖК», — своего счёта не заводим. */
    // ⛔ ПЕТЛЯ. Кнопка «Показать N ЖК» лежит ВНУТРИ наблюдаемой области, поэтому
    //    запись в неё будит того же наблюдателя, который вызвал refresh, — и так
    //    без конца. Страница вешалась намертво: вызов в браузере не возвращался
    //    две минуты. Два предохранителя: писать только при РЕАЛЬНОМ изменении
    //    текста и глушить наблюдателя на время записи.
    let mo = null;
    const set = (node, value) => {
      if (!node || node.textContent === value) return;
      node.textContent = value;
    };
    /* ⛔ «0» ДО ЗАГРУЗКИ И «0» ПОСЛЕ ОТБОРА — РАЗНЫЕ ВЕЩИ. Сервер печатает в
       счётчике «Найдено 0 квартир в 0 ЖК» и заполняет его скриптом уже после
       ответа API. Прежний код на этом основании молчал про число всегда, когда
       там ноль, — и человек, получивший пустой список (Курск + 2 комнаты +
       «Сданные»), видел сводку «kursk · 2» и кнопку «Показать ЖК» без ответа.
       Отличаем одно от другого по скелетону: его гасит `_render` при ПЕРВОЙ же
       отрисовке (`novostrojki.js`, `skeleton.style.display = 'none'`), то есть
       погашенный скелетон = число уже настоящее. Своего счётчика загрузки не
       заводим: он разошёлся бы с сайтом. */
    const skeleton = document.getElementById('nvSkeleton');
    const counted = () => !skeleton || skeleton.style.display === 'none'
      || !!document.querySelector('.nv-card');

    let busy = false;
    const refresh = () => {
      if (busy) return;
      busy = true;
      if (mo) mo.disconnect();
      const cityNode = document.getElementById('nvCityLabel');
      const city = humanLabel('city', txt(cityNode, '')) || 'Город';
      // Чиним подпись и на самой кнопке фильтра: слаг там от того же дефекта,
      // а сводка обязана сходиться с тем, что человек видит в фильтре.
      set(cityNode, city);
      const roomsNode = document.querySelector('#nvBtnRooms span');
      const roomsRaw = txt(roomsNode, 'Комнаты');
      const rooms = roomsRaw === 'Комнаты' ? 'любые комнаты' : humanLabel('rooms', roomsRaw);
      const jk = txt(totalJk, '0');
      const parts = [city, rooms];
      if (counted()) parts.push(jk + ' ЖК');
      set(desc, parts.join(' · '));
      set(done.querySelector('span'), doneLabel(jk, counted()));
      if (mo) watch();
      busy = false;
    };

    const watch = () => {
      const params = bar.querySelector('.zk-bar__params');
      if (params) mo.observe(params, { subtree: true, childList: true, characterData: true });
      if (totalJk) mo.observe(totalJk, { subtree: true, childList: true, characterData: true });
      // Перерисовка списка — единственный надёжный признак «число посчитано».
      // Счётчик #nvTotalJK при нулевой выдаче остаётся тем же «0», что и до
      // загрузки, и сам по себе наблюдателя не будит.
      const cards = document.getElementById('nvCards');
      if (cards) mo.observe(cards, { childList: true });
    };

    refresh();

    if (window.MutationObserver) {
      mo = new MutationObserver(refresh);
      watch();
    }
  }

  /* ─────────────────────────────────────────────────────────────────────
     КАТ-1: поведение выпадашки сортировки
     ───────────────────────────────────────────────────────────────────── */
  function wireSort(bar, sortBar) {
    const wrap = bar.querySelector('.zk-sort');
    const btn = wrap._btn;
    const val = wrap._val;

    const close = () => {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    };

    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    // Выбор пункта: родная кнопка отрабатывает сама (её слушатель приехал
    // вместе с ней), нам остаётся закрыть панель и обновить подпись.
    wrap.addEventListener('click', (e) => {
      const opt = e.target.closest ? e.target.closest('.nv-sort-btn') : null;
      if (!opt) return;
      val.textContent = txt(opt, 'По умолчанию');
      close();
    });

    document.addEventListener('click', (e) => {
      if (!wrap.contains(e.target)) close();
    });

    // Сайт сам переставляет .active при перерисовке списка — подпись обязана
    // это отражать, иначе кнопка врёт о текущем порядке.
    if (window.MutationObserver) {
      new MutationObserver(() => { val.textContent = currentSortLabel(sortBar); })
        .observe(sortBar, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('keydown', (e) => {
      if ((e.key === 'Escape' || e.key === 'Esc') && wrap.classList.contains('is-open')) close();
    });
  }

  /* ─────────────────────────────────────────────────────────────────────
     Шаг Б дизайна каталога (25.09.2026): вид выдачи «Плитка / 4 в ряд / Список»
     (спецификация Б.1, решения главного чата 1 и 2).

     ⛔ ВИД — ТОЛЬКО АТРИБУТ. На #nvCards (и на скелетон) ставится data-view =
        tile | tile4 | list, а что показать в карточке, решает CSS: разметка карточки
        одна на все виды, карточки не перестраиваются, фокус и прокрутка на месте.
     ⛔ СТАВИТСЯ ДО zk-ready: этот вызов идёт в start() раньше сборки коробки, а
        список открывается только классом zk-ready — вид не прыгает на глазах.
     ⛔ ПАМЯТЬ — localStorage `nv_view`, в адрес НЕ пишется (новых адресов для робота
        нет). Хранилище недоступно — вид «Плитка», каталог работает.
     ⛔ «4 В РЯД» ПОМЕЩАЕТСЯ только от 1680 и при свёрнутой колонке (или когда колонки
        нет): иначе плитка вышла бы уже 360 px. РЕШАЕТ ЭТО CSS, А НЕ СКРИПТ — договор
        этого файла («ни одной проверки ширины», см. шапку): сетка в 4 ряда и сама
        кнопка «4 в ряд» включаются в novostrojki.css только под @media (min-width:
        1680px) и классом свёрнутой колонки; в остальных случаях tile4 рисуется
        «Плиткой». Сохранённое «4 в ряд» НЕ перезаписывается: свернул колонку снова —
        вернулись 4 в ряд. Скрипт только сверяет отметку кнопок с тем, что видно:
        спрятанная кнопка не может быть отмеченной, тогда отмечена «Плитка».
     ───────────────────────────────────────────────────────────────────── */
  const VIEW_KEY = 'nv_view';
  const VIEWS = ['tile', 'tile4', 'list'];

  function readView() {
    try {
      const v = window.localStorage.getItem(VIEW_KEY);
      return VIEWS.indexOf(v) !== -1 ? v : 'tile';
    } catch (e) {
      return 'tile';   // приватный режим / хранилище закрыто
    }
  }

  function writeView(v) {
    try { window.localStorage.setItem(VIEW_KEY, v); } catch (e) { /* вид живёт до перезагрузки */ }
  }

  function initView() {
    const cards = document.getElementById('nvCards');
    if (!cards) return;
    const skel = document.getElementById('nvSkeleton');
    const sw = document.getElementById('nvViewSwitch');
    const html = document.documentElement;
    let saved = readView();

    const btns = () => (sw ? [...sw.querySelectorAll('[data-view-btn]')] : []);
    // Какая кнопка отмечена: сохранённая, если её видно; иначе «Плитка» (tile4 спрятан
    // стилем, когда 4 в ряд не помещаются — сетка при этом тоже плиточная).
    const marked = () => {
      const b = sw && sw.querySelector('[data-view-btn="' + saved + '"]');
      return saved === 'tile4' && (!b || b.offsetParent === null) ? 'tile' : saved;
    };

    let raf = 0;
    const apply = () => {
      raf = 0;
      if (cards.getAttribute('data-view') !== saved) cards.setAttribute('data-view', saved);
      if (skel && skel.getAttribute('data-view') !== saved) skel.setAttribute('data-view', saved);
      const on = marked();
      btns().forEach((b) => {
        const is = b.getAttribute('data-view-btn') === on;
        b.classList.toggle('is-active', is);
        b.setAttribute('aria-checked', is ? 'true' : 'false');
        b.tabIndex = is ? 0 : -1;
      });
    };
    const later = () => { if (!raf) raf = window.requestAnimationFrame ? window.requestAnimationFrame(apply) : (apply(), 0); };

    const choose = (b, focus) => {
      const v = b && b.getAttribute('data-view-btn');
      if (VIEWS.indexOf(v) === -1) return;
      saved = v;
      writeView(v);
      apply();
      if (focus) b.focus();
    };

    apply();

    if (sw) {
      sw.addEventListener('click', (e) => {
        const b = e.target.closest ? e.target.closest('[data-view-btn]') : null;
        if (b) choose(b, false);
      });
      // Группа радиокнопок: стрелки переходят по ВИДИМЫМ кнопкам («4 в ряд» бывает скрыта).
      sw.addEventListener('keydown', (e) => {
        const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step) return;
        const vis = btns().filter((b) => b.offsetParent !== null);
        const at = vis.indexOf(document.activeElement);
        if (at === -1 || !vis.length) return;
        e.preventDefault();
        choose(vis[(at + step + vis.length) % vis.length], true);
      });
    }
    // Отметка кнопок сверяется с видимым после «Скрыть» / «Показать фильтры» (класс на
    // <html> ставит novostrojki-filters.js) и после изменения окна — раз в кадр.
    if (window.MutationObserver) {
      new MutationObserver(later).observe(html, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', later, { passive: true });
  }

  const start = () => {
    try {
      initView();
    } catch (e) {
      /* вид — удобство: без него выдача остаётся плиткой из разметки сервера */
    }
    try {
      boot();
    } catch (e) {
      giveUp();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
